import PropTypes from 'prop-types';

export const MessageType = PropTypes.shape({
  author: PropTypes.shape({
    alias: PropTypes.string,
    imageId: PropTypes.string,
    userId: PropTypes.number,
  }),
  date: PropTypes.number,
  dislikeCount: PropTypes.number,
  id: PropTypes.number,
  loading: PropTypes.bool,
  name: PropTypes.string,
  isAdmin: PropTypes.bool,
  isHighlighted: PropTypes.bool,
  likeCount: PropTypes.number,
  text: PropTypes.string,
  userPic: PropTypes.number,
});

export const GameType = PropTypes.shape({
  atgProduct: PropTypes.string,
  betCode: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  betId: PropTypes.number,
  completedEvents: PropTypes.number,
  closeTime: PropTypes.number,
  date: PropTypes.number,
  dividend: PropTypes.number,
  events: PropTypes.number,
  eventStarted: PropTypes.bool,
  id: PropTypes.number,
  isActive: PropTypes.bool,
  lockTime: PropTypes.number,
  name: PropTypes.string,
  resultsCompleteAt: PropTypes.number,
  sportProduct: PropTypes.string,
  stake: PropTypes.number,
});
